import {
  FETCH_GUIDELINE_INDEX_FAILED,
  FETCH_GUIDELINE_INDEX_SUCCEEDED,
  FETCH_GUIDELINE_INDEX_STARTED,
} from '../action-types/guidelineIndexTypes';

const initialState = {
  briefHeaders: [],
  error: null,
  numberOfRecords: 0,
  isLoading: false,
  viewMoreIsEnabled: false,
};

const guidelineIndexReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GUIDELINE_INDEX_STARTED: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case FETCH_GUIDELINE_INDEX_SUCCEEDED: {
      return {
        ...state,
        isLoading: false,
        briefHeaders: [...state.briefHeaders, ...action.briefHeaders],
        numberOfRecords: action.numberOfRecords,
        viewMoreIsEnabled: state.briefHeaders.length < action.numberOfRecords,
      };
    }
    case FETCH_GUIDELINE_INDEX_FAILED: {
      return {
        ...initialState,
        err: action.err,
      };
    }
    default: {
      return state;
    }
  }
};

export default guidelineIndexReducer;
